import { getAccountPropertiesAsync } from './getAccountPropertiesAsync'

export const getMembershipPropertiesAsync = async (refresh: boolean) => {
  const { subscription } = await getAccountPropertiesAsync(refresh)

  return subscription || {}
}
